export default __webpack_public_path__ + "static/favicon-65a464a79eaec50dff4fdf08d2d46def.ico";